const getApiHostname = () => process.env.REACT_APP_API_HOSTNAME ?? '';

export default getApiHostname;
